import * as React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/app/queryClient";
import { ThemeModeProvider } from "@/theme/ThemeModeContext";
import { NotificationProvider } from "@/components/notifications/NotificationProvider";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider } from "@/context/AuthContext";
import { AppRouter } from "@/router/AppRouter";

export function App(): React.JSX.Element {
  return (
    <ErrorBoundary>
      <ThemeModeProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <NotificationProvider>
              <AppRouter />
            </NotificationProvider>
          </QueryClientProvider>
        </AuthProvider>
      </ThemeModeProvider>
    </ErrorBoundary>
  );
}
